import { NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  LayoutDashboard,
  Users,
  DoorOpen,
  Clock,
  ClipboardList,
  Coffee,
  Package,
  CreditCard,
  BarChart3,
  ListChecks,
} from 'lucide-react';
import useTranslation from '../../hooks/useTranslation';

const menuItems = [
  { labelKey: 'nav.dashboard', path: '/dashboard', icon: LayoutDashboard },
  { labelKey: 'nav.customers', path: '/customers', icon: Users },
  { labelKey: 'nav.rooms', path: '/rooms', icon: DoorOpen },
  { labelKey: 'nav.checkin', path: '/checkin', icon: Clock },
  { labelKey: 'nav.activeSessions', path: '/active-sessions', icon: ClipboardList },
  { labelKey: 'nav.cafe', path: '/cafe', icon: Coffee },
  { labelKey: 'nav.inventory', path: '/inventory', icon: Package },
  { labelKey: 'nav.expenses', path: '/expenses', icon: CreditCard },
  { labelKey: 'nav.reports', path: '/reports', icon: BarChart3 },
  { labelKey: 'nav.auditLogs', path: '/audit-logs', icon: ListChecks },
];

const Sidebar = ({ isCollapsed = false, onToggle }) => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <aside
      className={`
        bg-white border-s border-gray-200 h-full
        transition-all duration-300 ease-in-out
        ${isCollapsed ? 'w-20' : 'w-64'}
      `}
    >
      <div className="h-16 flex items-center justify-center border-b border-gray-200">
        {isCollapsed ? (
          <span className="text-2xl font-bold text-primary-600">S</span>
        ) : (
          <span className="text-xl font-bold text-primary-600">{t('app.name')}</span>
        )}
      </div>

      <nav className="p-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(`${item.path}/`);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onToggle}
              className={`
                flex items-center px-4 py-3 rounded-lg
                transition-colors duration-200
                ${isActive
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }
              `}
            >
              <Icon
                className={`h-5 w-5 flex-shrink-0 ${isCollapsed ? 'mx-auto' : ''}`}
              />
              {!isCollapsed && (
                <span className="font-medium ms-3">{t(item.labelKey)}</span>
              )}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};

Sidebar.propTypes = {
  isCollapsed: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default Sidebar;
